import {
  getUserCurrency,
  percentileDivisionFormatMoney,
} from 'src/mixins/currencyMixin';
import Description from 'src/components/transaction/description';
import DescriptionDeduction from 'src/components/transaction/description-deduction';
import TransactionType from 'src/components/transaction/transaction-type';
import invoice from 'src/components/transaction/invoice';
import DateDisplay from 'src/components/transaction/date-display';
import DetailDescription from 'src/components/transaction/detail-description';

const transactionTypeMap = {
  costs: '0',
  payment: '1',
  nonStandard: '4', // 非标
  taxes: '6',
  deduction: '9', // 优惠券
};

// 1-默认 pdf
// 2-xml下载
export const DownloadInvoiceType = {
  PDF: 1,
  XML: 2,
};

export const paymethodTypes = {
  CASH: {
    type: 'cash',
    name_i18n: 'module_transaction_paymethod_cash',
  },
  GRANT: {
    type: 'grant',
    name_i18n: 'module_transaction_paymethod_grant',
  },
  REBATE: {
    type: 'rebate',
    name_i18n: 'module_transaction_paymethod_rebate',
  },
};

const payTypeMap = {
  REBATE: 2, // 返点
  GRANT: 3, // 赠款
  CASH_PRE: 11, // 预付费现金
  CREDIT: 0, // 给后付费补位用
  // 不返回授信充值流水
};

const accountTypeMap = {
  // 账户类型
  PRE_AND_CREDIT: 0, // 预付&授信
  CREDIT: 1, // 后付费
};

const taxTypeMap = {
  // 计税类型
  UNSET: -1, // 未设定
  COST: 0, // 消耗计税
  CHARGE: 1, // 充值计税
};

const createDateDisplay = (vm, props) => vm.$createElement(DateDisplay, {
  props,
});

const createTransactionType = (vm, props) => vm.$createElement(TransactionType, {
  props,
});

const createDetailDescription = (vm, props) => vm.$createElement(DetailDescription, {
  props,
});

const createTaxItem = (vm = {}, props = {}, showId = true) => vm.$createElement(Description, {
  props: {
    ...props,
    showId,
  },
});
const createDeduction = (vm = {}, props = {}) => vm.$createElement(DescriptionDeduction, {
  props,
});
const createInvoice = (vm = {}, props = {}) => vm.$createElement(invoice, {
  props: {
    invoice: !props.invoice_info ? {} : props.invoice_info,
  },
});
const getPaymentDescription = (item = {}, vm = {}) => {
  if (item.transaction_type === +transactionTypeMap.deduction) {
    return createDeduction(vm, {
      deductionDetail: item,
    });
  }

  if (
    +item.transaction_type !== +transactionTypeMap.payment
  ) {
    // 非payment类型descreption无内容
    return '-';
  }
  const {
    transaction_id: id,
    account_type: accountType,
    tax_type: taxType,
    capital_attr: payType,
    tax_detail: taxDetail,
    pay_method: card,
    amount: totalAmount,
    balance_change: chargeAmount,
    payment_detail: paymentDetail,
  } = item;
  const taxProps = {
    id,
    taxDetail,
    card,
    totalAmount,
    chargeAmount,
    paymentDetail,
  };

  switch (
    payType // 支付方式
  ) {
    case payTypeMap.GRANT: // 赠款
      return vm.$t(paymethodTypes.GRANT.name_i18n);
    case payTypeMap.CASH_PRE: // 预付现金
      if (taxType === taxTypeMap.COST) {
        // 消耗计税
        return vm.$t(paymethodTypes.CASH.name_i18n);
      }
      if (taxType === taxTypeMap.CHARGE) {
        // 充值计税
        return createTaxItem(
          vm,
          { ...taxProps, card: vm.$t(paymethodTypes.CASH.name_i18n) },
          false,
        );
      }
      break;
    case payTypeMap.REBATE:
      return vm.$t(paymethodTypes.REBATE.name_i18n); // 其他现金类型
    default:
      // 其他方式
      if (accountType === accountTypeMap.CREDIT) {
        // 后付费类型
        // return createTaxItem(vm, taxProps, true);
        return createDetailDescription(vm, taxProps);
      }
      return vm.$t(paymethodTypes.CASH.name_i18n); // 其他 现金类型
  }
};
const invoiceFormatter = (row, vm) => createInvoice(vm, row);

const moneyFormatter = (row) => {
  const type = String(row.transaction_type);
  let amount = 0;
  switch (type) {
    case transactionTypeMap.deduction:
    case transactionTypeMap.payment: {
      const additionalSign = Number(row.amount) > 0 ? '+' : '';
      amount = `${additionalSign}${percentileDivisionFormatMoney(row.amount)}`;
      break;
    }
    case transactionTypeMap.costs:
    case transactionTypeMap.nonStandard:
    case transactionTypeMap.taxes:
      amount = `-${percentileDivisionFormatMoney(row.amount)}`;
      break;
    default:
      amount = percentileDivisionFormatMoney(row.amount);
  }
  return amount;
};

export const transactionTypesAll = [
  {
    label_i18n: 'module_transaction_type_all',
    value: Object.values(transactionTypeMap).join(','),
    type: 'all',
  },
  {
    label_i18n: 'module_transaction_type_payment',
    value: transactionTypeMap.payment,
    type: 'payment',
    hint_i18n: 'module_transaction_type_payment_hint',
  },
  {
    label_i18n: 'module_transaction_type_costs',
    value: transactionTypeMap.costs,
    type: 'costs',
    hint_i18n: 'module_transaction_type_costs_hint',
  },
  {
    label_i18n: 'module_transaction_type_costs_non_standard',
    value: transactionTypeMap.nonStandard,
    type: 'nonStandard',
    hint_i18n: 'module_transaction_type_costs_non_standard_hint',
  },
  {
    label_i18n: 'module_transaction_type_taxes',
    value: transactionTypeMap.taxes,
    type: 'taxes',
    hint_i18n: 'module_transaction_type_taxes_hint',
  },
  {
    label_i18n: 'module_transaction_type_deduction',
    value: transactionTypeMap.deduction,
    type: 'deduction',
    hint_i18n: 'module_transaction_type_deduction_hint',
  },
];

// export const transactionTypesWithoutTaxes = [
//   {
//     label_i18n: 'module_transaction_type_all',
//     value: `${transactionTypeMap.payment},${transactionTypeMap.costs}`,
//     type: 'all',
//   },
//   {
//     label_i18n: 'module_transaction_type_payment',
//     value: transactionTypeMap.payment,
//     type: 'payment',
//     hint_i18n: 'module_transaction_type_payment_hint',
//   },
//   {
//     label_i18n: 'module_transaction_type_costs',
//     value: transactionTypeMap.costs,
//     type: 'costs',
//     hint_i18n: 'module_transaction_type_costs_hint',
//   },
// ];

export const transactionTypesDefault = transactionTypesAll;

const transactionTypesMap = transactionTypesAll.reduce((res, item) => {
  res[item.value] = item;
  return res;
}, {});

export const dateTypes = [
  {
    label_i18n: 'module_transaction_current_month',
    value: 1,
    type: 'CURRENT_MONTH',
  },
  {
    label_i18n: 'module_transaction_previous_month',
    value: 2,
    type: 'PREVIOUS_MONTH',
  },
  {
    label_i18n: 'module_transaction_last_3_month',
    value: 3,
    type: 'LAST_3_MONTH',
  },
  {
    label_i18n: 'module_transaction_last_6_month',
    value: 4,
    type: 'LAST_6_MONTH',
  },
  {
    label_i18n: 'module_transaction_this_year',
    value: 5,
    type: 'THIS_YEAR',
  },
  // {
  //   label_i18n: 'module_transaction_last_12_month',
  //   value: 6,
  //   type: 'LAST_12_MONTH',
  // },
  {
    label_i18n: 'module_transaction_time_all',
    value: 7,
    hint_i18n: 'module_transaction_time_all_hint',
    type: 'ALL_TIME',
  },
];

export const dateTypesMap = dateTypes.reduce((res, item) => {
  res[item.type] = item.value;
  return res;
}, {});

export const defaultFilters = {
  transactionType: transactionTypesDefault[0].value,
  dateType: 3,
};

const createTransactionTypeFormatter = vm => row => createTransactionType(vm, {
  row,
  text: transactionTypesMap[row.transaction_type].label_i18n,
  transactionTypeMap,
});

export const getTableColumns = vm => [
  {
    title: vm.$t('module_transaction_column_date'),
    key: 'date',
    fixed: 'left',
    'min-width': 240,
    hint: vm.$t('module_transaction_column_date_tooltip'),
    // formatter: row => row.transaction_date,
    formatter: row => createDateDisplay(vm, { row }),
  },
  {
    title: vm.$t('module_transaction_column_type'),
    key: 'type',
    'min-width': 180,
    hint: vm.$t('module_transaction_column_transaction_type_tooltip'),
    // formatter: row => vm.$t(transactionTypesMap[row.transaction_type].label_i18n),
    formatter: createTransactionTypeFormatter(vm),
  },
  {
    title: vm.$t('module_transaction_column_description'),
    key: 'description',
    'min-width': 480,
    hint: vm.$t('module_transaction_column_description_tooltip'),
    formatter: row => getPaymentDescription(row, vm),
  },
  {
    title: `${vm.$t(
      'module_transaction_column_amount',
    )} (${getUserCurrency()})`,
    key: 'amount',
    'min-width': 190,
    align: 'right',
    hint: vm.$t('module_transaction_column_amount_hint'),
    formatter: row => moneyFormatter(row),
  },
];

// 自助用户
export const getSelfTableColumns = vm => [
  {
    title: vm.$t('module_transaction_column_date'),
    key: 'date',
    fixed: 'left',
    'min-width': 240,
    hint: vm.$t('module_transaction_column_date_tooltip'),
    // formatter: row => row.transaction_date,
    formatter: row => createDateDisplay(vm, { row }),
  },
  {
    title: vm.$t('module_transaction_column_type'),
    key: 'type',
    'min-width': 180,
    hint: vm.$t('module_transaction_column_transaction_type_tooltip'),
    // formatter: row => vm.$t(transactionTypesMap[row.transaction_type].label_i18n),
    formatter: createTransactionTypeFormatter(vm),
  },
  {
    title: vm.$t('module_transaction_column_description'),
    key: 'description',
    'min-width': 255,
    hint: vm.$t('module_transaction_column_description_tooltip'),
    formatter: row => getPaymentDescription(row, vm),
  },
  {
    title: `${vm.$t(
      'module_transaction_column_amount',
    )} (${getUserCurrency()})`,
    key: 'amount',
    width: 165,
    align: 'right',
    hint: vm.$t('module_transaction_column_amount_hint'),
    formatter: row => moneyFormatter(row),
  },
  {
    title: vm.$t('module_transaction_column_invoice'),
    key: 'invoice',
    'min-width': 240,
    formatter: row => invoiceFormatter(row, vm),
  },
];

// 流水类型映射
export const newTransactionTypeMap = {
  payments: '1',
  costs: '2',
  tax: '3',
};

// payments类型映射
export const paymentsTypeMap = {
  payments: '1',
  promotions: '2',
  adjustments: '3',
};

// summary数据类型映射
export const summaryDataMap = {
  campaignCosts: '1',
  payments: '2',
  promotions: '3',
  adjustments: '4',
};

// summary数据类型i18n key映射
export const summaryDataTitleI18nKeyMap = {
  [summaryDataMap.campaignCosts]: 'module_transaction_total_campaign_costs',
  [summaryDataMap.payments]: 'module_transaction_total_payments',
  [summaryDataMap.promotions]: 'module_transaction_total_promotions',
  [summaryDataMap.adjustments]: 'module_transaction_total_adjustments',
};

// tab类型
export const transactionTabType = {
  payments: '1',
  costs: '2',
};

// tab类型i18n key映射
export const transactionTabTypeI18nKeyMap = {
  [transactionTabType.payments]: 'module_transaction_tab_payments',
  [transactionTabType.costs]: 'module_transaction_tab_costs',
};


// 流水状态
export const transactionStatusMap = {
  processing: '0', // 合并类型1 跟 2前端使用 代表未处理状态
  pending: '1', // 待处理
  handling: '2', // 处理中
  paid: '3', // 已支付
  failed: '4', // 失败
};

export const transactionStatusDataMap = {
  [transactionStatusMap.processing]: {
    i18nKey: 'common_processing',
    className: 'processing',
  },
  [transactionStatusMap.paid]: {
    i18nKey: 'common_paid',
    className: 'paid',
  },
  [transactionStatusMap.failed]: {
    i18nKey: 'common_failed',
    className: 'failed',
  },
};

export const billingTransactionTypeMap = {
  TOP_UP: '101',
  CANCEL: '102',
  AUTOPAY_BILL: '801',
  MI_BILL: '901',
  ISSUED: '301',
  EXPIRED: '302',
  CHECKOUT: '1',
  CHECKOUT_BACK: '2',
  REFUND: '103',
  TRANSFER_IN: '501',
  TRANSFER_OUT: '502',
};

const getBillingTransactionTypeSymbolMap = status => ({
  get [billingTransactionTypeMap.TOP_UP]() {
    return status === transactionStatusMap.paid ? '+ ' : '';
  },
  [billingTransactionTypeMap.CANCEL]: '- ',
  get [billingTransactionTypeMap.AUTOPAY_BILL]() {
    return status === transactionStatusMap.paid ? '+ ' : '';
  },
  get [billingTransactionTypeMap.MI_BILL]() {
    return status === transactionStatusMap.paid ? '+ ' : '';
  },
  [billingTransactionTypeMap.ISSUED]: '+ ',
  [billingTransactionTypeMap.EXPIRED]: '- ',
  [billingTransactionTypeMap.CHECKOUT]: '',
  [billingTransactionTypeMap.CHECKOUT_BACK]: '',
  [billingTransactionTypeMap.REFUND]: '- ',
  [billingTransactionTypeMap.TRANSFER_IN]: '+ ',
  [billingTransactionTypeMap.TRANSFER_OUT]: '- ',
});

const noData = ['', null, undefined];

export function handleFormatterVal(val) {
  return noData.includes(val) ? '-' : val;
}


export function formatterAmount(amount, currency, status, type) {
  if (isNaN(Number(amount))) return '-';
  const symbol = getBillingTransactionTypeSymbolMap(status)[type] ?? '';
  const absAmount = symbol ? Math.abs(Number(amount)) : amount;
  return `${symbol}${percentileDivisionFormatMoney(absAmount)} ${currency}`;
}

// 使用类型映射关系
export const usageConditionMap = {
  AD_CREDIT: ['2', '3', '-9999999'],
  COUPON: ['1'],
};

export const promotionsStatusDataMap = {
  [billingTransactionTypeMap.ISSUED]: {
    i18nKey: 'common_issued',
    className: 'issued',
  },
  [billingTransactionTypeMap.EXPIRED]: {
    i18nKey: 'common_expired',
    className: 'expired',
  },
};

export const adjustmentTypeMap = {
  CARD_VERIFICATION: [billingTransactionTypeMap.CHECKOUT],
  CARD_VERIFICATION_REFUND: [billingTransactionTypeMap.CHECKOUT_BACK],
  REFUND: [billingTransactionTypeMap.REFUND],
  TRANSFER_IN: [billingTransactionTypeMap.TRANSFER_IN],
  TRANSFER_OUT: [billingTransactionTypeMap.TRANSFER_OUT],
};

export const newTransactionTaxTypeMap = {
  // 计税类型
  UNSET: '-1', // 未设定
  COST: '0', // 消耗计税
  CHARGE: '1', // 充值计税
};


export function getCommonColumns(vm, columns) {
  return [
    {
      title: vm.$t('module_transaction_column_time'),
      key: 'transaction_time',
      width: 160,
      formatter: row => handleFormatterVal(row.transaction_time),
    },
    ...columns,
    {
      title: vm.$t('module_transaction_column_amount'),
      key: 'amount',
      width: 180,
      align: 'right',
      formatter: row => formatterAmount(
        row?.stat_data?.amount,
        row?.currency,
        row?.transaction_status,
        row?.stat_data?.billing_transaction_type,
      ),
    },
  ];
}

// table通用属性
export const commonDataKeyObj = {
  listDataKey: 'list',
  amountDataKey: 'amount',
  currencyDataKey: 'currency',
};
